import React from 'react';
import ExcelJS from 'exceljs';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { Button } from 'react-bootstrap';

const ExportToExcelButton = ({ data, filename, sheetName, headerText, headerColor }) => {
    const handleExport = async () => {
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();

        // Add a worksheet
        const worksheet = workbook.addWorksheet(sheetName || 'Sheet1');
        const newdata = data.filter(dev => dev.developer === "Bhavna Rathore");
       
        // Define headers and check if 'azure' platform exists
        const headers = [
            "Developer Name",
            "Agent Running",
            "Repository Name",
            "Last Commit Date",
            "Commits",
            "Files Changed",
            "LOC: Total",
            "Non-Call Worked Hours",
            "InCall Hours",
            "Suspicious Lines",
            "Merged PRs",
            "LOC: Modified ", 
            "Not Committed Suspicious Lines",
            "LOC: Total Adjusted",
            "LOC: Deleted",
            "LOC: Added",
            "Declined PRs",
            "Open PRs",
            "PR Comments",
            // Conditional headers based on platform      
            // "Total",
            // "Merged PRs",       
            "PRC Ratio"
        ];

        // If platform is not azure, we should remove 'LOC: Modified'
        // const filteredHeaders = headers.filter(header =>
        //     header !== "LOC: Modified " || data.every(item => item.platform === 'AzureDevOps')
        // );

        // Add header row and merge cells
        worksheet.addRow([headerText]);
        worksheet.mergeCells(`A1:${String.fromCharCode(64 + headers.length)}1`); // Dynamically merge based on the number of headers

        const headerCell = worksheet.getCell('A1');
        // Style the header
        headerCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: headerColor || 'FFADD8E6' }, // Light blue default
        };
        headerCell.font = {
            bold: true,
            size: 16,
        };

        // Add column headers
        worksheet.addRow(headers);

        // Style cells and set column widths for filtered headers
        headers.forEach((header, index) => {
            const colLetter = String.fromCharCode(65 + index); // Get the column letter (A, B, C, etc.)
            const cell = worksheet.getCell(colLetter + '2'); // Target the header cells (A2, B2, C2, etc.)
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF000000' } // Black background
            };

            // Set column width
            worksheet.getColumn(index + 1).width = header.length + 2; // Adjust width as needed
            worksheet.getColumn(index + 1).alignment = { vertical: "middle", horizontal: "left" }; // Adjust width as needed
        });

        headerCell.alignment = { vertical: 'middle', horizontal: 'center' };

        // Add data rows
        data.forEach(item => {
            // Prepare data for the row, excluding LOC: Modified if platform is not azure
            const row = [
                item.developer,
                item.isRunning,
                item.repoName,
                item.lastDate,
                item.totalCommits,
                item.totalFilesChanged,
                item.changesCountTotal,
                item.totalHoursWorked,
                item.totalHoursWorkedInCall,
                item.suspectedLinesCount,
                item.totalMergedPrs,
                // Exclude LOC: Modified value if platform is not azure
                item.platform !== 'AzureDevOps' ? null : item.changesTotal - item.changesCountRemoved - item.changesCountAdd,
                item.notCommittedLinesCount,
                item.changesCountTotal,
                item.changesCountRemoved,
                item.changesCountAdd,
                item.totalDeclinedPrs,
                item.totalOpenPrs,
                item.totalPrComments,
                (item.totalPrComments / item.changesCountTotal).toFixed(6),
            ].filter(value => value !== null); // Filter out null values for "LOC: Modified" when platform is not azure

            worksheet.addRow(row);
        });

        // Generate the Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Save the file
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${filename}.xlsx`);
    };

    return (
        <Button color='info' onClick={handleExport} style={{ float: "right", marginBottom: '10px' }}>
            <i className="fa fa-file-excel" aria-hidden="true" />&nbsp;Export to Excel
        </Button>
    );
};

ExportToExcelButton.propTypes = {
    data: PropTypes.array.isRequired,
    filename: PropTypes.string.isRequired,
    sheetName: PropTypes.string.isRequired,
    headerText: PropTypes.string.isRequired,
    headerColor: PropTypes.string.isRequired,
}

export default ExportToExcelButton;
